<template>
    <v-row>
        <v-col
            v-for="statistic in statistics"
            :key="statistic.id"
            :statistic="statistic"
            cols="12"
            lg="3"
            class="chart-wrapper d-none d-lg-inline"
        >
            <div id="chart" class="chart">
                <apexchart
                    type="radialBar"
                    height="200"
                    :options="chartOptions"
                    :series="[statistic.percent]"
                />
            </div>
            <span>{{ statistic.name }}</span>
        </v-col>
    </v-row>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import Vue from 'vue';
Vue.component('apexchart', VueApexCharts);

export default {
    components: {
        apexchart: VueApexCharts
    },
    props: {
        statistics: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            interval: {},
            value: 0,
            options: {},
            chartOptions: {
                plotOptions: {
                    radialBar: {
                        startAngle: 0,
                        endAngle: 360,
                        hollow: {
                            margin: 0,
                            size: '60%',
                            background: '#fff',
                            position: 'front'
                        },
                        track: {
                            background: '#e8e8e8',
                            strokeWidth: '50%',
                            margin: 0
                        },

                        dataLabels: {
                            name: {
                                show: false
                            },
                            value: {
                                formatter: function(val) {
                                    return parseInt(val) + '%';
                                },
                                color: '#000000',
                                fontSize: '27px',
                                offsetY: 10,
                                show: true
                            }
                        }
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#ae00cb'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                },
                stroke: {
                    lineCap: 'round'
                },
                labels: ['Percent']
            }
        };
    },

    mounted() {
        this.interval = setInterval(() => {
            if (this.value === 70) {
                return (this.value = 70);
            }
            this.value += 10;
        }, 150);
    }
};
</script>

<style lang="scss" scoped>
.chart-wrapper {
    width: 140px;
    float: left;
    display: block;
    position: relative;

    .chart {
        float: left;
        width: 50%;
        position: relative;
    }

    span {
        display: block;
        position: relative;
        width: 50%;
        float: left;
        margin-top: 50px;
    }
}

.v-progress-circular__overlay {
    cursor: pointer;
    stroke: url(#MyGradient);
}
</style>
